import {
  IClaimsTicketDetails,
  IPriorAuthTicketDetails
} from '@shared/services/service-mappers/WorkflowMapper';
import {UseFormMethods} from 'react-hook-form';

export interface ITicketingSystemTicketDetailsModuleFieldsProps {
  renderFields: (props: {
    methods: UseFormMethods;
    isEditing: boolean;
    ticketDetails: IPriorAuthTicketDetails | IClaimsTicketDetails | null;
    refreshTicketDetails: () => void;
    isLoadingTicketDetails: boolean;
  }) => JSX.Element;
  methods: UseFormMethods<any>;
  isEditing: boolean;
  ticketDetails: IPriorAuthTicketDetails | IClaimsTicketDetails | null;
  refreshTicketDetails: () => void;
  isLoadingTicketDetails: boolean;
}

const TicketingSystemTicketDetailsModuleFields = (
  props: ITicketingSystemTicketDetailsModuleFieldsProps
): JSX.Element => {
  return props.renderFields({
    methods: props.methods,
    isEditing: props.isEditing,
    ticketDetails: props.ticketDetails,
    refreshTicketDetails: props.refreshTicketDetails,
    isLoadingTicketDetails: props.isLoadingTicketDetails
  });
};

export default TicketingSystemTicketDetailsModuleFields;
